export default __webpack_public_path__ + "static/media/IMG_2374.a667cc82.jpg";